import React from 'react';
import { Users, Lock, CheckCircle, TrendingUp } from 'lucide-react';
const marqueeItems = [{
  icon: <Lock className="w-4 h-4 text-[#25D366]" data-id="element-240" />,
  text: 'Pago 100% Seguro'
}, {
  icon: <Users className="w-4 h-4 text-[#25D366]" data-id="element-241" />,
  text: 'Más de 400 comerciantes ya transformaron su negocio'
}, {
  icon: <Lock className="w-4 h-4 text-[#25D366]" data-id="element-242" />,
  text: 'Pago 100% Seguro'
}, {
  icon: <CheckCircle className="w-4 h-4 text-[#25D366]" data-id="element-243" />,
  text: 'Acceso inmediato después de la compra'
}, {
  icon: <Lock className="w-4 h-4 text-[#25D366]" data-id="element-244" />,
  text: 'Pago 100% Seguro'
}, {
  icon: <TrendingUp className="w-4 h-4 text-[#25D366]" data-id="element-245" />,
  text: 'Resultados desde la primera semana'
}, {
  icon: <Lock className="w-4 h-4 text-[#25D366]" data-id="element-246" />,
  text: 'Pago 100% Seguro'
}, {
  icon: <Users className="w-4 h-4 text-[#25D366]" data-id="element-247" />,
  text: 'Más de 400 comerciantes ya transformaron su negocio'
}];
export function UrgencyBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a] border-b border-[#25D366]/20 overflow-hidden" data-id="element-248">
      <div className="flex animate-marquee whitespace-nowrap py-2.5" data-id="element-249">
        {marqueeItems.map((item, index) => <div key={index} className="inline-flex items-center gap-2 mx-8 text-sm font-medium" data-id="element-250">
            {item.icon}
            <span className="text-gray-300" data-id="element-251">{item.text}</span>
            <span className="text-[#25D366]/30 ml-6" data-id="element-252">✦</span>
          </div>)}
        {/* Duplicate for seamless loop */}
        {marqueeItems.map((item, index) => <div key={`dup-${index}`} className="inline-flex items-center gap-2 mx-8 text-sm font-medium" data-id="element-253">
            {item.icon}
            <span className="text-gray-300" data-id="element-254">{item.text}</span>
            <span className="text-[#25D366]/30 ml-6" data-id="element-255">✦</span>
          </div>)}
      </div>
    </div>;
}